<!-- Sidebar -->
<div class="sidebar sidebar-style-2">
  <div class="sidebar-wrapper scrollbar scrollbar-inner">
    <div class="sidebar-content">
      <ul class="nav nav-primary">
        <li class="nav-item submenu" *ngFor="let menu of sideBarMenu" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          <a data-toggle="collapse" href="#{{ menu.MainmenuID }}">
            <i class="far fa-plus-square"></i>
            <p>{{ menu.MainmenuItem }}</p>
            <span class="caret"></span>
          </a>
          <div class="collapse" id="{{ menu.MainmenuID }}">
            <ul class="nav nav-collapse">
              <li *ngFor="let submenuItem of menu.Submenu" [routerLinkActive]="'active'">
                <a [routerLink]="[submenuItem.RoutingPath]">
                  <span class="sub-item">{{ submenuItem.SubmenuItem }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>